import { useSelector, useDispatch } from 'react-redux'
import { Field, Form, FormikProvider, useField, useFormik } from 'formik';
import React, { useEffect, useRef, useState, forwardRef } from 'react'
import { AuthStdFooter } from "../../utils/auth-std-footer";
// import { useDropzone } from 'react-dropzone';
// import { setArticleText } from '../../slices/articleEditorSlice'
// import { addArticle, deleteArticle, fetchArticle, fetchArticles, fetchArticleContent, selectAllArticles, selectArticleContent } from '../../slices/coreAssetsSlice'

import { addArticle, deleteArticle, fetchArticles, fetchArticleContent, selectArticleContent } from '../../slices/coreAssetsSlice'
// import useRefreshS3CredentialsForEditor from '../../utils/refreshS3CredentialsForEditor';
import { FileDropzone } from '../../utils/fileDropZone';
import { fetchSignedUrlByType } from '../../utils/fetchSignedUrlByFolderV2';
import { allRoutes } from '../../constants/config'

import FormikDatePicker from '../../components/formikDatePicker';
import EmailTagHelp from '../../components/EmailTagHelp';
import FormikDropdown from '../../components/formikDropdown';
// import DatePicker from "react-datepicker";
import _ from 'lodash'

import { Button, Checkbox, Dropdown, Grid, Input, Label } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';

import UtilityModal from '../../utils/modal-helper'
import logo from '../../assets/clear_text_fields_x.svg';
import headphonesMicSpeaker from '../../assets/headphones-mic-speaker.jpg'

import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/js/plugins/file.min.js";

import "froala-editor/js/plugins/image.min.js";
import "froala-editor/css/plugins/image.min.css";
import "froala-editor/js/plugins/image_manager.min.js";
import "froala-editor/js/plugins/inline_class.min.js";
import "froala-editor/css/plugins/image_manager.min.css";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import 'font-awesome/css/font-awesome.css';

import FroalaEditor from 'react-froala-wysiwyg';
import { EMBED_REGISTRY } from '../../components/articleEmbeds/registry';
import Froalaeditor from "froala-editor";

import '../../styles/article.css'
import "react-datepicker/dist/react-datepicker.css";
import useIsLoggedIn from '../../isLoggedIn';

/**
 * ─── INTERACTIVE EMBEDS IN ARTICLE BODIES ───────────────────────────────────────────────────
 *
 * An article can host a live React component by carrying a plain-text token in its body:
 *
 *     [[aai-embed:architecture-explorer]]
 *     [[aai-embed:architecture-explorer view=sequences]]
 *
 * ⭐ TEXT, NOT MARKUP, and that is the whole reason it survives. The body passes through TWO
 * sanitisers — Froala on save, DOMPurify on render — and either is free to strip an element or
 * attribute it does not recognise, silently, in published content nobody re-checks. A sanitiser
 * cannot strip text.
 *
 * The toolbar button is a convenience: it types the token for you and lists what exists. Typing
 * it by hand works identically, which matters because a custom Froala command is one upgrade away
 * from breaking and the published articles must not be.
 *
 * Registry (name → component): components/articleEmbeds/registry.js
 * Renderer: components/articleEmbeds/ArticleEmbedHost.jsx, reached via utils/contentFetcher.
 */
Froalaeditor.DefineIcon('aaiEmbed', { NAME: 'star', SVG_KEY: 'star' });
Froalaeditor.RegisterCommand('aaiEmbed', {
  title: 'Insert interactive embed',
  type: 'dropdown',
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  options: Object.fromEntries(
    Object.entries(EMBED_REGISTRY).map(([name, meta]) => [name, meta.label || name])
  ),
  callback(cmd, name) {
    const meta = EMBED_REGISTRY[name];
    const view = meta && meta.params
      ? (meta.params.find((p) => p.name === 'view') || {}).default
      : null;
    // Its own paragraph, so the renderer can replace the whole block instead of leaving an empty
    // <p> hanging above the embed.
    this.html.insert(`<p>[[aai-embed:${name}${view ? ` view=${view}` : ''}]]</p>`);
  }
});

const { API_UPLOAD_FILE, IMAGE_UPLOAD_URL, AAI_API_MOVE_FILE, API_EMAIL_SUBTYPES } = { ...allRoutes }

Froalaeditor.DefineIcon("save", { NAME: "floppy-o fa-lg", template: "font_awesome" });
Froalaeditor.RegisterCommand('save', {
  title: 'Save',
  focus: false,
  undo: false,
  refreshAfterCallback: false,
  callback: function () {
    console.log('Saving me');
  }
});

const categoryOptions = [{ key: '0', text: "News", value: 0 },
{ key: '1', text: "Article Item", value: 1 },
{ key: '2', text: "Tutorial", value: 2 },
{ key: '3', text: "History", value: 3 },
/**
 * ⭐ EMAIL is a reserved category, not another kind of article. Its items are email TEMPLATES:
 * they never appear in the Info listing (getArticlesList filters by category and the Info page
 * never requests this one), and their body is read by the SERVER at send time rather than fetched
 * by a browser — which is why §EMAIL_INLINE_CONTENT below stores it differently.
 */
{ key: '4', text: "Email", value: 4 }]

const EMAIL_CATEGORY = 'email';
// other imports...
// const articleListOptions = [{ key: 'news', text: "News", value: 'news' },
// { key: 'staytuned', text: "Stay Tuned...", value: 'staytuned' },
// { key: 'possibilites', text: "Possiblities swirl like a storm...", value: 'possibilites' },
// { key: "wegettoit", text: "We get to it...", value: "wegettoit" }]

let articleListOptions = [{ key: 'noitems', text: "Article Item", value: 'noitems', data: {} }]


// Custom Input Field
const CustomInputField = ({ field, form, ...props }) => {
  return <Input {...field} {...props} />
};

const CustomTextarea = ({ field, form, ...props }) => {
  return <textarea {...field} {...props} className='ble-textarea ble-textarea-border form-input-mostly-wide' />;
};

const CustomCheckBox = ({ field, form, ...props }) => {
  return (
    // ⚠️ NO className HERE — it must come through `props` from the <Field> that renders this.
    // Hardcoding `className='ble-checkbox'` on this element did not reach whatever Semantic ends
    // up styling, so the CSS rule was correct, loaded, and inert. Verified against the running
    // page: on the Field it works, here it does not.
    <Checkbox
      checked={field.value}
      onChange={(e, { checked }) => form.setFieldValue(field.name, checked)}
      {...props}
    />
  );
};

// ⛔ TAKES THE REF ITSELF, NOT ITS VALUE.
//
// This used to receive the ref's `.current` as a prop. The parent clears that ref inside a
// setTimeout with no state update, so React never re-renders and the prop stays frozen at the
// value it held when the form was reset: true. onModelChange then took its else branch forever and
// never wrote the editor's content into Formik — so the content field never differed from its
// initial value, and Submit (which keys off formik.dirty) stayed disabled no matter what was typed
// or dragged in.
//
// Editing the excerpt appeared to fix it because that re-rendered the parent, at which point the
// prop was finally re-read as false. Hence the folklore: change the excerpt, then re-add the image.
//
// Reading `.current` at call time makes the value current by construction, which is the whole point
// of a ref and the reason passing one by value is a mistake rather than a style choice.
const FormikFroalaEditor = ({ name, isFormResettingRef, initialContent, category, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const editorRef = useRef(null);

  // const [currentCategory, setCurrentCategory] = useState(category);
  let currentCategory = useRef(category)

  // ⛔ `helpers` MUST NOT BE A DEPENDENCY, and it was.
  //
  // Formik's useField returns a freshly-built `helpers` object on every render, so listing it here
  // made this effect run on EVERY render — pinning the content field back to `initialContent` each
  // time. React bails out when the value is identical, so there was no visible loop; what there
  // was, was every editor edit being silently reverted a render later.
  //
  // The symptom was precise and confusing: dragging an image into the body did not enable Submit,
  // because Submit keys off `formik.dirty` and the content field never differed from its initial
  // value. Changing another field (the excerpt) made the form dirty by a different route, which is why
  // "change the excerpt, then re-add the image" appeared to work.
  //
  // Apply the initial content only when it genuinely changes — loading a different article — and
  // never on top of a user's edits.
  const appliedInitialContent = useRef(null);
  useEffect(() => {
    if (initialContent && appliedInitialContent.current !== initialContent) {
      appliedInitialContent.current = initialContent;
      helpers.setValue(initialContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialContent]);

  useEffect(() => {
    // console.log('FormikFroalaEditor category ', category)
    currentCategory.current = category
    // setCurrentCategory(category);
  }, [category]);

  return (
    <FroalaEditor
      ref={editorRef}
      model={field.value}
      onModelChange={(model) => {
        // helpers.setValue(model);
        // Read at call time — see the note on this component.
        if (!(isFormResettingRef && isFormResettingRef.current)) {
          helpers.setValue(model);
        }

      }}
      config={{
        iframe: false,
        // Froala Pro license key now sourced from the single source of truth in
        // constants/config.js (allRoutes is a spread copy of config). Updated
        // 2026-07-13 after the previous key expired ("Expired copy of Froala
        // Editor" on the prod domain; localhost is license-exempt).
        // Previous keys (for history):
        //   'oc1F2vD1A1F1A1B2B6mEZXQUVJb1EZf1IWIAUKLJZMBQuD3E2D1C1C4G1G4F1A11B6=='
        //   '2J1B10dA5F5C4F4C3B3I3C-22VKOG1FGULVKHXDXNDXc2a1Kd1SNdF3H3A8D7D4F4A3E3D2A15=='
        key: allRoutes.FORMIX_KEY,

        attribution: false,
        htmlAllowComments: true,
        // getS3OpType: () => { return this.getEditorImagePath(); },
        // imageUploadParams: { articleTypeFolder: 'news' },
        imageUploadParams: {},

        imageUploadParam: 'file',
        imageUploadURL: IMAGE_UPLOAD_URL,

        /**
         * ⛔ REQUIRED NOW THAT THE UPLOAD ROUTES ARE GUARDED. Froala posts the file itself, not
         * through apiClient, so it carries no credentials unless told to — and both article upload
         * routes write into the PUBLICLY READABLE `aai-core/articles/**` prefix, which is why they
         * stopped accepting anonymous callers.
         *
         * ⚠️ Read at render rather than captured at module load: a token refreshed mid-session must
         * not leave the editor posting a stale one. `authToken` is the literal key used everywhere
         * else that touches it.
         */
        requestHeaders: {
          Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
        },

        imageUploadMethod: 'POST',

        imageMaxSize: 5 * 1024 * 1024,
        fileMaxSize: 1024 * 1024 * 5,
        fileAllowedTypes: ['application/pdf'],
        fileUploadMethod: 'POST',
        fileUploadParam: 'file_name',
        fileUploadURL: API_UPLOAD_FILE,
        fileUploadParams: { id: 'my_editor' },
        // imageUploadToS3: true, //this.props.s3Hash.data,
        placeholderText: 'Edit Your Content Here!',
        charCounterCount: true,
        reactIgnoreAttrs: ['class', 'id'],
        // imageEditButtons: ['imageDisplay', 'imageAlign', 'imageInfo', 'imageRemove'],
        htmlAllowedAttrs: ['friendly_url', 'accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap'],
        imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif', 'webp', 'svg', 'svg+xml'],
        // toolbarButtons: [['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript'], ['fontFamily', 'fontSize', 'textColor', 'backgroundColor'], ['inlineClass', 'inlineStyle', 'clearFormatting']],
        // toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote'],
        toolbarButtons: {
          moreText: {
            buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
            buttonsVisible: 3
          },
          moreParagraph: {
            buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
            buttonsVisible: 2
          },
          moreRich: {
            // `aaiEmbed` inserts an interactive component token — see the block above the
            // component. Placed first in this group because it is the one button here that adds
            // something the WYSIWYG cannot otherwise express.
            buttons: ['aaiEmbed', 'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertFiles', 'insertHR'],
            buttonsVisible: 4
          },
          moreMisc: {
            buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'save', 'help'],
            align: 'right',
            buttonsVisible: 2
          }
        },
        // toolbarButtons: [['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript'], ['fontFamily', 'fontSize', 'textColor', 'backgroundColor'], ['inlineClass', 'inlineStyle', 'clearFormatting']],
        fontFamilyDefaultSelection: 'futura-pt',
        fontFamilySelection: true,
        fontSizeSelection: true,
        fontFamily: {
          "futura-pt, Roboto, 'Open Sans Condensed', sans-serif": 'Futura, Roboto, Open Sans Condensed, sans-serif',
          'Arial,Helvetica,sans-serif': 'Arial,Helvetica,sans-serif',
          "Lato,'Helvetica Neue', Arial, Helvetica, sans-serif": "Lato, Helvetica Neue, Arial, Helvetica, sans-serif",
          "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif": "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
          "Verdana, Geneva, Tahoma, sans-serif": "Verdana, Geneva, Tahoma, sans-serif",
          "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif": "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
          "'Times New Roman', Times, serif": "'Times New Roman', Times, serif"
        },
        inlineClasses: {
          'articleTitle': 'Note Heading',
          'articleAuthor': 'Author Style',
          'articleDate': 'articleDate',
          'articleContent': 'Content Text',
        },
        paragraphStyles: {
          'articleAuthor': 'Author Style',
          'articleAuthorContainer': 'Content Container',
        },
        tableStyles: {
          'transparentTable': 'Transparent Style',
        },
        tableCellStyles: {
          'imagePadAll': 'Padding 10'
        },
        imageStyles: {
          'imageRounded': 'Rounded Image',
          'imagePadAll': 'Padding All 10'
        },
        // fileUploadToS3: {
        //   bucket: 'aai-api', // Update this to your S3 bucket name
        //   region: 'us-west-1', // Update this to the region of your S3 bucket
        //   keyStart: 'aai-core/temp/', // Update this to the desired key prefix in your S3 bucket       
        //   params: {
        //     acl: 'public-read', // ACL according to Amazon Documentation.
        //     AWSAccessKeyId: config.AWS_SECRET_ACCESS_KEY, //'ACCESS_KEY', // Access Key from Amazon.
        //     policy: 'POLICY_STRING', // Policy string computed in the backend.
        //     signature: '', // Signature computed in the backend.

        //     // If you are using Amazon Signature V4, the followings should be used instead.
        //     // "X-Amz-Credential": "...",
        //     // "X-Amz-Algorithm": "AWS4-HMAC-SHA256",
        //     // "X-Amz-Date": "...",
        //     // Policy: "...", //
        //     // "X-Amz-Signature": "", // computed in backend
        //   }
        // },
        events: {
          'image.beforeUpload': function () {
            // // Check if category is selected
            // console.log('image.beforeUpload category', currentCategory.current)
            // if (!currentCategory.current || currentCategory.current === 'unknown') {
            //   alert("Please select a category before uploading images.");
            //   return false; // Cancel upload
            // }
          },     // Return false if you want to stop the image upload.
          'image.uploaded': function (response) { },       // Image was uploaded to the server.
          'image.inserted': function ($img, response) { }, // Image was inserted in the editor.
          'image.replaced': function ($img, response) { }, // Image was replaced in the editor.
          'image.error': function (error, response) {
            if (error.code === 1) { console.log('ERROR 1', error) } // Bad link.
            else if (error.code === 2) { console.log('ERROR 2', error) } // No link in upload response.
            else if (error.code === 3) { console.log('ERROR 3', error) } // Error during image upload.
            else if (error.code === 4) { console.log('ERROR 4', error) } // Parsing response failed.
            else if (error.code === 5) { console.log('ERROR 5', error) } // Image too text-large.
            else if (error.code === 6) { console.log('ERROR 6', error) } // Invalid image type.
            else if (error.code === 7) { console.log('ERROR 7', error) } // Image can be uploaded only to same domain in IE 8 and IE 9.
            // Response contains the original server response to the request if available.
          },
          'file.beforeUpload': function (files) {
            // ⛔ FILE ATTACHMENTS STAY DISABLED, and returning false is what disables them.
            //
            // This used to hand `files` to useCustomFileUpload, which posted them to the literal
            // string 'your-s3-upload-url' — so attachments have never uploaded anywhere. The hook
            // is gone; the `return false` is kept deliberately.
            //
            // ⚠️ `fileUploadURL` IS configured (API_UPLOAD_FILE), so deleting this handler would
            // let Froala start posting there for the first time. That may well work, but it is a
            // behaviour change to an untested endpoint and belongs in its own decision, not in a
            // cleanup that removes dead code.
            return false;
          },
          'file.uploaded': function (response) { },        // File was uploaded to the server.
          'file.inserted': function ($file, response) { }, // File was inserted in the editor.
          'file.error': function (error, response) {
            if (error.code === 1) { } // Bad link.
            else if (error.code === 2) { } // No link in upload response.
            else if (error.code === 3) { } // Error during file upload.
            else if (error.code === 4) { } // Parsing response failed.
            else if (error.code === 5) { } // File too text-large.
            else if (error.code === 6) { } // Invalid file type.
            else if (error.code === 7) { } // File can be uploaded only to same domain in IE 8 and IE 9.
            // Response contains the original server response to the request if available.
          }
        }
      }}
      tag="textarea"
      {...props}
    />
  );
}

const ArticleEditor = ({ titleText }) => {
  const dispatch = useDispatch()
  useSelector((state) => {
    // console.log('allArticles', state.core.articles.articles);
    if (state.core.articles.articles) {
      articleListOptions = state.core.articles.articles.map((x) => {
        // Use UUID as key to avoid duplicates
        return { key: x.uuid, text: x.name, value: x.uuid, data: x }
      })
      // console.log('allArticles', articleListOptions);

    }
    return state.core.articles.articles;
  })
  const userProfile = useSelector(state => state.user.profile);

  let isResetting = useRef(false)
  const [heroImg, setHeroImg] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [artListDropdownOpen, setArtListDropdownOpen] = useState(false);
  // const [counter, setCounter] = useState(0);
  const [open, setOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null)
  let articleUuid = useRef("")
  const foundArticleRef = useRef(null);
  let latestContent = useRef(null)

  let heroImgSignedUrl = useRef({})
  let thumbnailSignedUrl = useRef({})
  let contentSignedUrl = useRef({})
  let formContent = useRef("")

  const articleContent = useSelector(state => {
    let newContent = selectArticleContent(state, articleUuid.current)
    latestContent.current = newContent
    return newContent
  });

  const authToken = useIsLoggedIn();

  /**
   * ⭐ THE SUBTYPE REGISTRY COMES FROM THE SERVER, not a copy here. A duplicated list drifts, and
   * a subtype the editor offers but the renderer does not declare is a template that authors fine
   * and then never matches a lookup — an email that silently never sends.
   *
   * ⓘ The server returns only LIVE subtypes, so a declared-but-unbuilt one cannot be authored
   * against by mistake.
   */
  const [emailSubtypes, setEmailSubtypes] = useState([]);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) return;
        const res = await fetch(API_EMAIL_SUBTYPES, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setEmailSubtypes(data.subtypes || []);
      } catch (_) { /* the editor still works without it; the dropdown is simply empty */ }
    })();
    return () => { cancelled = true; };
  }, []);

  const initialValues = {
    title: '',
    author: '',
    startDate: new Date(),
    updatedDate: new Date(),
    category: [],
    heroImg: null,
    thumbnail: null,
    excerpt: '',
    content: '',
    contentUrl: '',
    enabled: true,
    // ⓘ Only meaningful when the category is Email; null for every other article.
    emailSubtype: '',
    emailSubject: '',
  };

  useEffect(() => {
    // ⓘ includeEmail: the editor must see the templates it authors. The public Info pages do
    // NOT pass this, so email templates stay out of the public article list.
    let props = { uuid: '2cc388cb-ae96-3edb-1136-14c1b0c0324d', reqCategories: "", includeEmail: 'true' }
    dispatch(fetchArticles(props))
      .unwrap()
      .then((data) => {
        // handle success here
        // console.log('success articles fetch', data)
      })
      .catch((error) => {
        // handle error here
        // console.log('failed articles fetch', error.message)

      });

  }, [dispatch, authToken])

  async function uploadFileToS3(signedUrl, file) {
    await fetch(signedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type
      },
      body: file
    });
  }


  async function uploadHtmlToS3(signedUrl, htmlString) {
    fetch(signedUrl, {
      method: 'PUT',
      body: new Blob([htmlString], { type: 'text/html' }),
      headers: {
        'Content-Type': 'text/html'
      },
    }).then(response => {
      if (!response.ok) {
        throw new Error('Upload failed: ' + response.statusText);
      }
      console.log('Upload succeeded!');
    }).catch(error => {
      console.error('Error:', error);
    });
  }

  const getArticleFolder = () => {
    // console.log('getArticleFolder', formik.values);
    // console.log('getArticleFolder category', formik.values.category);
    let category = formik.values.category;
    if (!category) return 'unknown'
    if (_.isEmpty(category)) return 'unknown'
    if (_.isArray(category) && category.length < 1) return 'unknown'

    let folderName = ""
    if (_.isNumber(category[0])) {
      folderName = categoryOptions[Number(category[0])].text.toLowerCase()
    }
    else {
      // Convert underscores back to spaces for matching (for backwards compatibility)
      let catText = category[0].replace(/_/g, ' ').toUpperCase()
      let index = _.findIndex(categoryOptions, (x, idx) => { return x.text.toUpperCase() === catText; })

      // Safety check: if no match found, return the category as-is (it's already a folder name)
      if (index === -1) {
        return category[0];
      }

      folderName = categoryOptions[index].text.toLowerCase()
    }

    folderName = folderName.replace(/[^a-zA-Z0-9 ]/g, "");
    folderName = folderName.replace(/\s+/g, "_");
    // console.log('getArticleFolder folderName', folderName);

    if (folderName) return folderName
    return 'unknown'
  }


  const submitForm = async (formValues) => {

    /**
     * §EMAIL_INLINE_CONTENT
     * ⭐⭐ AN EMAIL TEMPLATE STORES ITS BODY INLINE; EVERY OTHER ARTICLE DOES NOT.
     *
     * ⛔ Ordinary articles send `content: ""` and keep the HTML in S3, fetched by the browser via
     * contentUrl — every existing article has content length 0. Left that way, saving an email
     * template in this editor would SILENTLY EMPTY IT: templateStore reads art.content, so
     * renderTemplate would refuse with `no-body`, the code fallback would quietly take over, and the
     * operator's edits would appear to do nothing.
     *
     * ⭐ The storage difference follows the CONSUMPTION difference: an email body is read by the
     * SERVER at send time, not by a browser. Fetching S3 mid-send would add a network round trip and
     * a new way for a send to fail, to no benefit — the body is a few hundred bytes.
     *
     * ⓘ The S3 upload still happens, so an email template remains viewable like any other article.
     */
    const isEmail = getArticleFolder() === EMAIL_CATEGORY;

    let saveArticleParams = {
      author: formValues.author,
      categories: [getArticleFolder()],
      content: isEmail ? (formContent.current || formValues.content || '') : "",
      emailSubtype: isEmail ? (formValues.emailSubtype || null) : null,
      emailSubject: isEmail ? (formValues.emailSubject || null) : null,
      contentUrl: contentSignedUrl.current.baseUrl,
      createdAt: formValues.startDate.toString(),
      enabled: formValues.enabled,
      excerpt: formValues.excerpt,
      heroImageUrl: heroImgSignedUrl.current.baseUrl,
      name: formValues.title,
      thumbnailImageUrl: thumbnailSignedUrl.current.baseUrl,
      updatedOn: formValues.updatedDate.toString(),
      uuid: formValues.uuid ? formValues.uuid : uuidv4(),
    }

    console.log('submitForm', saveArticleParams)
    // const { uuid, name, enabled, author, categories, excerpt, heroImageUrl, thumbnailImageUrl, contentUrl, content } = req.body;

    // author: "authorboss"
    // categories: ["NEWS"]
    // content: ""
    // contentUrl: "https://aai-api.s3.us-west-1.amazonaws.com/aai-core/articles/news/content/testTextDoc_3.txt"
    // createdAt: 2023-07-11T18:57:56.392000000Z
    // enabled: true
    // excerpt: "Our team of developers are hard at work, making this happen...whatever it is."
    // heroImageUrl: "https://aai-api.s3.us-west-1.amazonaws.com/aai-core/articles/news/images/thodkin_A_device_like_a_tornado_injests_book_produces_voice_pac_92e9ab2d-46f1-474c-a61f-8e3417f5e61c.png"
    // name: "We Get To It"
    // thumbnailImageUrl: "https://aai-api.s3.us-west-1.amazonaws.com/aai-core/articles/news/images/thodkin_Android_mech_as_a_scientist_at_futuristic_workstation_w_131b2096-3904-4b5b-85d7-f573c1d0f3dd.png"
    // updatedOn: 2023-07-11T18:57:56.392000000Z
    // uuid: "b6579b30-5332-ac59-0038-3b4041ad7abf"

    dispatch(addArticle(saveArticleParams));

  }

  function extractUrls(content) {
    const regex = /<img src="https:\/\/aai-api\.s3\.us-west-1\.amazonaws\.com\/aai-core\/temp[^"]+"/g;
    return content.match(regex);
  }

  const moveAllFiles = async () => {
    const urls = extractUrls(formik.values.content);
    formContent.current = formik.values.content;

    if (urls) {
      // map urls to an array of promises
      const promises = urls.map(async url => {
        const oldKey = url.slice('<img src="https://aai-api.s3.us-west-1.amazonaws.com/'.length, -1); // remove the leading part and trailing quotation mark
        const fileName = oldKey.split("/").pop(); // get the filename from the oldKey
        const categorySubFolderName = getArticleFolder(); // this must be set before submitting - or submitting must be inhibited (which it should be because the button only goes live with valid fields)

        // let adjustedFileName = fileName.replace(/ /g, '-');
        let adjustedFileName = fileName.replaceAll('%20', "-")
        const newKey = `aai-core/articles/${categorySubFolderName}/images/${adjustedFileName}`; // construct the new key with the desired location and filename

        // make a GET request to your server endpoint
        const response = await fetch(`${AAI_API_MOVE_FILE}/${encodeURIComponent(oldKey)}/${encodeURIComponent(newKey)}`);

        if (response.ok) {
          const jsonResponse = await response.json();
          const newUrl = jsonResponse.newUrl;

          // replace the old url with the new url in formik.values.content
          formContent.current = formContent.current.replace(url, `<img src="${newUrl}"`)
        } else {
          // ⚠️ A FAILED MOVE LEAVES A DEAD URL IN THE ARTICLE. The rewrite below is skipped, so
          // formContent.current keeps pointing at aai-core/temp/… — and the move may already have
          // deleted the object. The article then saves with a broken image and nothing says so.
          //
          // Named loudly here because this editor has no error surface to raise it in, and the
          // symptom (an image that vanishes some time later) reads as unrelated to this moment.
          console.error(
            `[ArticleEditor] IMAGE MOVE FAILED — the article will save with a dead link.\n`
            + `  from : ${oldKey}\n`
            + `  to   : ${newKey}\n`
            + `  cause: ${response.status} ${response.statusText}`
          );
        }
      });

      // await all promises to be resolved
      await Promise.all(promises);
    }
  }

  const formik = useFormik({
    initialValues: { ...initialValues },

    // initialValues: { heroImg: null, thumbnail: null },
    onSubmit: async (values, { resetForm }) => {
      const { heroImg, thumbnail, title } = values;
      // articles/news/images/
      let articleTypeName = getArticleFolder()

      // Generate or get the article UUID early
      const articleUuid = values.uuid || foundArticleRef.current?.uuid || uuidv4();

      // Check if heroImg and thumbnail are new files or existing URLs
      const isHeroImgFile = heroImg instanceof File;
      const isThumbnailFile = thumbnail instanceof File;

      // Step 1: Get the signed URLs for new files only
      if (isHeroImgFile) {
        // Use UUID-based naming for files
        const heroExt = heroImg.name.split('.').pop();
        const heroFileName = `${articleUuid}_hero.${heroExt}`;

        const heroSignedUrl = await fetchSignedUrlByType({
          requestType: 'ADMIN_PATH',
          userId: userProfile.data.userId,
          rootGroup: 'articles',
          infoType: articleTypeName,
          folderName: 'images',
          fileName: heroFileName
        });

        // Extract base URL (without query parameters) and store both
        heroImgSignedUrl.current.signedUrl = heroSignedUrl;
        heroImgSignedUrl.current.baseUrl = heroSignedUrl ? heroSignedUrl.split('?')[0] : '';

        // Upload new file
        await uploadFileToS3(heroImgSignedUrl.current.signedUrl, heroImg);
      } else {
        // Use existing URL
        heroImgSignedUrl.current.baseUrl = heroImg;
      }

      if (isThumbnailFile) {
        // Use UUID-based naming for files
        const thumbExt = thumbnail.name.split('.').pop();
        const thumbFileName = `${articleUuid}_thumbnail.${thumbExt}`;

        const thumbSignedUrl = await fetchSignedUrlByType({
          requestType: 'ADMIN_PATH',
          userId: userProfile.data.userId,
          rootGroup: 'articles',
          infoType: articleTypeName,
          folderName: 'images',
          fileName: thumbFileName
        });

        // Extract base URL (without query parameters) and store both
        thumbnailSignedUrl.current.signedUrl = thumbSignedUrl;
        thumbnailSignedUrl.current.baseUrl = thumbSignedUrl ? thumbSignedUrl.split('?')[0] : '';

        // Upload new file
        await uploadFileToS3(thumbnailSignedUrl.current.signedUrl, thumbnail);
      } else {
        // Use existing URL
        thumbnailSignedUrl.current.baseUrl = thumbnail;
      }

      setHeroImg(null)
      setThumbnail(null)

      // Step 3: Move any temporary files to desired locations (using current category as target folder)
      await moveAllFiles()

      // Step 4: Get the signed URL for the content text file
      // Use UUID-based naming for content
      const contentFileName = `${articleUuid}_content.html`;
      const contentSignedUrlValue = await fetchSignedUrlByType({
        requestType: 'ADMIN_PATH',
        userId: userProfile.data.userId,
        rootGroup: 'articles',
        infoType: articleTypeName,
        folderName: 'content',
        fileName: contentFileName
      });

      // Extract base URL (without query parameters) and store both
      contentSignedUrl.current.signedUrl = contentSignedUrlValue;
      contentSignedUrl.current.baseUrl = contentSignedUrlValue ? contentSignedUrlValue.split('?')[0] : '';
      // NOTE: Must explicitly get formContent.current after it has been updated by moveAllFiles. 
      //       moveAllFiles is where temp files are moved to target location.
      uploadHtmlToS3(contentSignedUrl.current.signedUrl, formContent.current)


      // Step 5: Write metadata to DB with UUID
      await submitForm({ ...values, uuid: articleUuid });

      // ⛔ RESET TO WHAT WAS JUST SAVED, NOT TO THE EMPTY BASELINE.
      //
      // A bare resetForm() restores `initialValues`, where content is ''. So immediately after a
      // successful save the editor was redrawn from an empty baseline and the text that had just
      // been written to S3 vanished from the screen — saved correctly, displayed wrongly, which is
      // the worst of both because it looks like data loss.
      //
      // Passing the submitted values keeps them on screen AND makes them the new clean baseline,
      // so formik.dirty goes false and Submit disables again — which is what "saved" should look
      // like.
      //
      // ⛔ CONTENT MUST COME FROM formContent.current, NOT FROM `values`. This line originally
      // reset with `values.content` and that silently destroyed images.
      //
      // `values.content` is the PRE-MOVE html: its <img> tags still point at aai-core/temp/…,
      // and moveAllFiles has just COPIED THOSE OBJECTS TO THE ARTICLE FOLDER AND DELETED THE
      // TEMP ONES. So the editor was left holding URLs to files that no longer exist. The first
      // save looked fine — S3 received formContent.current, which is correct — and the damage
      // only appeared on the NEXT save: extractUrls matched the stale temp URLs again,
      // moveAllFiles tried to move objects that were already gone, CopyObject failed, the
      // `response.ok` branch skipped the rewrite, and the dead temp URL was written to S3 as the
      // article's content. The image was then missing on every subsequent load.
      //
      // ⚠️ Note the failure mode: the first save is clean, so the bug appears one edit later and
      // looks unrelated to the save that caused it.
      resetForm({ values: { ...values, content: formContent.current, uuid: articleUuid } });
    },
  });

  useEffect(() => {
    if (latestContent.current && foundArticleRef.current) {
      let selectedFormInitialValues = {
        uuid: foundArticleRef.current.uuid,  // Include UUID for updates
        title: foundArticleRef.current.name,
        author: foundArticleRef.current.author,
        startDate: new Date(foundArticleRef.current.createdAt),
        updatedDate: new Date(foundArticleRef.current.updatedOn),
        category: foundArticleRef.current.categories,
        // ⓘ Undefined on every ordinary article; the fields are only rendered for the Email category.
        emailSubtype: foundArticleRef.current.emailSubtype || '',
        emailSubject: foundArticleRef.current.emailSubject || '',
        heroImg: foundArticleRef.current.heroImageUrl,
        thumbnail: foundArticleRef.current.thumbnailImageUrl,
        excerpt: foundArticleRef.current.excerpt,
        content: latestContent.current,
        contentUrl: foundArticleRef.current.contentUrl,
        enabled: foundArticleRef.current.enabled,
      }
      // setIsResetting(true)
      isResetting.current = true
      console.log("isResetting IS SET")
      formik.resetForm({ values: selectedFormInitialValues });

      setHeroImg(foundArticleRef.current.heroImageUrl)
      setThumbnail(foundArticleRef.current.thumbnailImageUrl)
      foundArticleRef.current = null;
      latestContent.current = null;

      setTimeout(() => {
        isResetting.current = false
        console.log("isResetting IS CLEARED")
        getDirtyFields(formik, 'DIRTY FORMIX USE_EFFECT - articleContent')

        // setCounter(prevCounter => prevCounter + 1);

      }, 200)

      // setIsResetting(false)
    }
  }, [formik, articleContent]);

  useEffect(() => {
    formik.content = articleContent
  }, [formik, articleContent])

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleModalCancel = () => {
    setOpen(false)
  }

  const handleOverwrite = () => {
    setOpen(false)
    let selectedUuid = selectedArticle;
    if (selectedUuid !== "") {

    }
    if (selectedUuid && selectedUuid !== "") {
      let foundArticle = articleListOptions.find((x, index) => x.key === selectedUuid)?.data;

      articleUuid.current = foundArticle.uuid;
      foundArticleRef.current = foundArticle;
      dispatch(fetchArticleContent({ articleUuid: foundArticle.uuid, contentUrl: foundArticle.contentUrl }));
    }
    else {
      formik.resetForm({
        values: initialValues
      })
      setHeroImg(null)
      setThumbnail(null)
      setSelectedArticle(null)
      // setCounter(prevCounter => prevCounter + 1);

    }
  }

  const handleModalSave = () => {
    console.log('handleModalSave')
    setOpen(false)
  }

  const handleDeleteArticle = () => {
    if (articleUuid.current && articleUuid.current !== "") {
      setDeleteModalOpen(true);
    }
  }

  const confirmDeleteArticle = async () => {
    if (articleUuid.current && articleUuid.current !== "") {
      try {
        await dispatch(deleteArticle({ uuid: articleUuid.current })).unwrap();
        console.log('Article deleted successfully');

        // Reset the form after successful deletion
        formik.resetForm({ values: initialValues });
        setHeroImg(null);
        setThumbnail(null);
        setSelectedArticle(null);
        articleUuid.current = "";
        foundArticleRef.current = null;

        // Refresh the articles list
        await dispatch(fetchArticles({ uuid: '2cc388cb-ae96-3edb-1136-14c1b0c0324d', reqCategories: "" }));
      } catch (error) {
        console.error('Error deleting article:', error);
      }
    }
    setDeleteModalOpen(false);
  }

  const cancelDeleteArticle = () => {
    setDeleteModalOpen(false);
  }

  const getDirtyFields = (formik, hint) => {

    let dirtyData = []
    const fieldsAreDirty = Object.entries(formik.values).reduce((result, [key, value]) => {

      result[key] = JSON.stringify(value) !== JSON.stringify(formik.initialValues[key]);
      if (result[key]) {
        dirtyData[key] = { key: key, data: JSON.stringify(value) }
      }
      return result;
    }, {});
    // console.log('getDirtyFields', hint, 'dirty fields', fieldsAreDirty, 'data', dirtyData)
    return fieldsAreDirty;
  }

  // Return true, if allowed to submit (so, disabled Button if !enableSubmit)
  const enableSubmit = () => {
    // Always disable Submit during submitting
    // if it is a new article, articleUuid.current will not be a uuid
    // in that case all fields must be entered to enable the submit button
    // console.log('enableSubmit', articleUuid.current)
    let isAllFilled = false
    if (articleUuid.current === "") {
      let excludedKeys = ['contentUrl']
      let testValues = _.omit(formik.values, excludedKeys)
      isAllFilled = Object.values(testValues).every(val => val !== null && val !== '');

    }
    else {
      // Otherwise, any field that is dirty will enable the submit button
      isAllFilled = formik.dirty;
      getDirtyFields(formik, 'DIRTY FORMIKS ENABLE SUBMIT -----')
    }
    return isAllFilled && !formik.isSubmitting;
  }

  const CustomInput = forwardRef(({ value, onClick }, ref) => {
    return (
      <button className="dateField" type="button" onClick={onClick} ref={ref} > {value} </button>
    )
  }
  );

  const handleClearAll = () => {
    if (formik.dirty) {
      setOpen(true)
    }
    else {
      setHeroImg(null) // image src field
      setThumbnail(null) // image src field
      formik.resetForm({
        values: initialValues
      })
      setSelectedArticle(null)
      // setCounter(prevCounter => prevCounter + 1);
    }
  }

  const handleOpen = () => {
    setDropdownOpen(true);
  };

  const handleClose = () => {
    setDropdownOpen(false);
  };

  const changeCategory = (value) => {
    formik.setFieldValue('category', value);
  }
  const handleArticleDDOpen = () => {
    setArtListDropdownOpen(true);
  };

  const handleArticleDDClose = () => {
    setArtListDropdownOpen(false);
  };

  const changeArticle = (value) => {
    console.log('changeArticle', value)

    if (formik.dirty) {
      setOpen(true)
      setSelectedArticle(value)
    }
    else {
      setHeroImg(null) // image src field
      setThumbnail(null) // image src field
      // formik.resetForm({
      //   values: initialValues
      // })
      // setSelectedArticle(value)
      let foundArticle = articleListOptions.find((x, index) => x.key === value)?.data;
      // if (foundArticle) {
      //   articleUuid.current = foundArticle.uuid;
      // }

      if (foundArticle) {
        articleUuid.current = foundArticle.uuid;
        foundArticleRef.current = foundArticle;
        dispatch(fetchArticleContent({ articleUuid: foundArticle.uuid, contentUrl: foundArticle.contentUrl }));
      }
      else {
        formik.resetForm({
          values: initialValues
        })
      }
      // else {
      //   setArticle(value)
      //   setFormToArticle(value)
      // }
    }
    // setCounter(prevCounter => prevCounter + 1);

  }

  return (
    <>
      <FormikProvider value={formik}>
        <div style={{ marginBottom: "70px", maxWidth: "1024px" }}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}> <span className="listTitle" style={{ display: "block", width: "1024px", marginBottom: "-15px" }}>{titleText ? titleText : "Article Editor"}</span></Grid.Column>
              <Grid.Column width={8} style={{ alignSelf: 'flex-end' }}>
                <div style={{ display: 'flex', alignItems: 'center', float: "right" }}>
                  <Label className='form-label'>Article</Label>
                  <Dropdown
                    className={artListDropdownOpen ? 'no-radius-dropdown-open' : 'no-radius-dropdown'}
                    onOpen={handleArticleDDOpen} onClose={handleArticleDDClose}
                    placeholder='Articles'
                    selection
                    onChange={(event, { value }) => { changeArticle(value) }}
                    options={articleListOptions}
                    value={selectedArticle} // Use state for value
                    style={{ zIndex: "10000", marginLeft: '10px' }} // add some margin to the left if needed
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={3} style={{ alignSelf: 'flex-end' }}>
                <Button className="ble-buttonHeight-38" basic onClick={handleClearAll} >New Article</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Form>
            <Grid className="form-grid" style={{ marginRight: "0px" }}>
              <Grid.Row style={{ paddingTop: "0px" }}>
                <Grid.Column width={8}>
                  <Field name="heroImg">
                    {() => <FileDropzone setFieldValue={formik.setFieldValue} fieldName="heroImg"
                      onDropCallback={(url) => setHeroImg(url)}
                      hintText={"Drag 'n' drop here, or click to select file"} altText={"Hero preview"}
                      imgItem={heroImg} />}
                  </Field>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Field name="thumbnail">
                    {() => <FileDropzone setFieldValue={formik.setFieldValue} fieldName="thumbnail"
                      onDropCallback={(url) => setThumbnail(url)}
                      hintText={"Thumbnail: Drag 'n' drop here, or click to select file"} altText={"Thumbnail preview"}
                      imgItem={thumbnail} />}
                  </Field>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row className="form-row">
                <Label className='form-label' htmlFor="title">Title</Label>
                <Field id="title" className='form-input-mostly-wide' name="title" as={CustomInputField} type="text" />
              </Grid.Row>
              <Grid.Row className="form-row">
                <Label className='form-label' htmlFor="author">Author</Label>
                <Field id="author" className='form-input-medium' name="author" as={CustomInputField} type="text"
                />
              </Grid.Row>
              <Grid.Row className="form-row">
                <FormikDropdown name="category" label="Categories"
                  options={categoryOptions}
                  dropdownOpen={dropdownOpen}
                  handleOpen={handleOpen} handleClose={handleClose}
                  changeCategory={changeCategory}
                />
              </Grid.Row>

              {/*
                ⭐ EMAIL-ONLY FIELDS. Rendered only when the category is Email, because a subject
                line and a subtype are meaningless on an article nobody mails — and an always-visible
                field that does nothing most of the time teaches people to ignore it.
              */}
              {getArticleFolder() === EMAIL_CATEGORY && (
                <>
                  <Grid.Row className="form-row">
                    <Label className='form-label' htmlFor="emailSubtype">Email purpose</Label>
                    <Field id="emailSubtype" name="emailSubtype" as="select" className='form-input-medium'>
                      <option value="">— choose —</option>
                      {emailSubtypes.map((st) => (
                        <option key={st.subtype} value={st.subtype}>{st.label}</option>
                      ))}
                    </Field>
                  </Grid.Row>

                  <Grid.Row className="form-row">
                    <Label className='form-label' htmlFor="emailSubject">Subject line</Label>
                    <Field id="emailSubject" className='form-input-medium' name="emailSubject"
                      as={CustomInputField} type="text" />
                  </Grid.Row>

                  <EmailTagHelp
                    subtype={formik.values.emailSubtype}
                    subtypes={emailSubtypes}
                    subject={formik.values.emailSubject}
                    body={formik.values.content}
                  />
                </>
              )}
              <Grid.Row className="form-row margin-left-zero">
                <Grid.Column width={4}> <FormikDatePicker name="startDate" label="Start Date" CustomInput={CustomInput} /> </Grid.Column>
                <Grid.Column width={4}> <FormikDatePicker name="updatedDate" label="Updated" CustomInput={CustomInput} /> </Grid.Column>
              </Grid.Row>
              <Grid.Row className="form-row">
                <Label className='form-label' htmlFor="excerpt">Excerpt</Label>
                <Field id="excerpt" name="excerpt" as={CustomTextarea} />
              </Grid.Row>
              <Grid.Row className="form-row">
                <Label className='form-label' htmlFor="enabled">Enable</Label>
                <Field name="enabled" className='ble-checkbox' component={CustomCheckBox} />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} >
                  {articleUuid.current && articleUuid.current !== "" && (
                    <Button type="button" basic color='red' style={{ width: "100%" }} onClick={handleDeleteArticle}>
                      Delete Article
                    </Button>
                  )}
                </Grid.Column>
                <Grid.Column width={3} ></Grid.Column>
                <Grid.Column width={3} >
                  <Button type="button" basic style={{ width: "100%", padding: "6px 10px 6px 10px", display: "flex", }} icon onClick={handleClearAll} >
                    <span style={{ marginRight: "15px", marginLeft: "8px", marginTop: "5px" }}>Clear All Fields</span>
                    <img src={logo} style={{ height: "1.75rem" }} alt="Clear all fields" />
                  </Button>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Button basic color='blue' type="submit" disabled={!enableSubmit()} style={{ width: "100%" }} > Submit</Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="form-row form-row-no-top-pad">
                <h2>Content</h2>
                <FormikFroalaEditor name="content" isFormResettingRef={isResetting} initialContent={latestContent.current} category={getArticleFolder()} />
              </Grid.Row>
            </Grid>
          </Form>
          <UtilityModal isOpen={open}
            handleModalClose={handleModalClose}
            handleCancel={handleModalCancel}
            handleOverwrite={handleOverwrite}
            handleSave={handleModalSave} promptObj={{
              image: headphonesMicSpeaker,
              modal_header: 'Warning - Unsaved Data',
              header_text: 'Complete Editing, Overwrite or Save',
              description_text: <div><p>
                You have unsaved data. This data will be lost if you choose Overwrite. If you Cancel, you can continue editing your existing changes. Or, you can save your changes and proceed with your new selection.
              </p>
                <p>Cancel, Overwrite, or Save Data?</p></div>,
              button_neg_text: 'Cancel',
              button_pos_text: "Overwrite",
              button_save_text: "Save"
            }} />
          <UtilityModal isOpen={deleteModalOpen}
            handleModalClose={cancelDeleteArticle}
            handleCancel={cancelDeleteArticle}
            handleOverwrite={confirmDeleteArticle}
            promptObj={{
              image: headphonesMicSpeaker,
              modal_header: 'Confirm Delete',
              header_text: 'Delete Article',
              description_text: <div><p>
                Are you sure you want to delete this article? This action cannot be undone.
              </p></div>,
              button_neg_text: 'Cancel',
              button_pos_text: "Delete",
            }} />
        </div>
      </FormikProvider>
    </>
  )
}

export default ArticleEditor;
